export const SERVER_CONFIG_LOADED='SERVER_CONFIG_LOADED'
export const SERVER_ERROR='SERVER_ERROR'
export const SET_ENVID='SET_ENVID'
export const CLEAR_ERROR='CLEAR_ERROR'


export const init = () => dispatch => {
    return fetch('/apisurl.json')
      .then(response => response.json())
      .then(json => dispatch(receiveConfig( json)))
}


export const receiveConfig = ( json) => {
  return ({
    type: SERVER_CONFIG_LOADED,
    payload : json
  })
}

export const serverError=(error,onModalClose)=>{

  return ({
    type:SERVER_ERROR,
    error: error,
    onModalClose: onModalClose
})
}

export const clearError=()=>{
  return({
    type:CLEAR_ERROR
  })
}


export const receiveEnvID=(envID)=>{
  return({
    type: SET_ENVID,
    envID: envID
  })
}